export default __webpack_public_path__ + "static/media/mShorts_1.d5debc91.bin";